import React from "react";
import PropTypes from "prop-types";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { SFArrowDownIcon } from "../icons";

export const SFAccordionDetails = (props) => {
  return <AccordionDetails {...props}>{props.children}</AccordionDetails>;
};

SFAccordionDetails.propTypes = {
  children: PropTypes.node,
};

export const SFAccordionSummary = ({
  children,
  iconColor,
  expandIcon,
  expandClickIconOnly = true,
  sx,
  ...props
}) => {
  return (
    <AccordionSummary
      expandIcon={expandIcon ?? <SFArrowDownIcon color="white"/>}
      sx={{
        "& .MuiAccordionSummary-expandIconWrapper svg": {
          color: iconColor,
          ...expandClickIconOnly && ({pointerEvents: "auto"})
        },
        ...expandClickIconOnly && ({pointerEvents: "none"}),
        ...sx,
      }}
      {...props}
    >
      {children}
    </AccordionSummary>
  );
};

SFAccordionSummary.propTypes = {
  children: PropTypes.node,
  iconColor: PropTypes.string,
  expandIcon: PropTypes.node,
  expandClickIconOnly: PropTypes.bool
};

const SFAccordion = ({ expanded, children, disabled, onChange, ...props }) => {
  return (
    <Accordion
      sx={{
        boxShadow: "none",
        ":before": {
          display: "none",
        },
        ...props.sx,
      }}
      expanded={expanded}
      disabled={disabled}
      onChange={onChange}
      {...props}
    >
      {children}
    </Accordion>
  );
};

SFAccordion.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SFAccordion;
